import "./ModalHeader.css";

function EyeMark() {
  return (
    <svg
      className="modal-header-eye"
      width="28"
      height="20"
      viewBox="0 0 112 48"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M0 24 C14 5 38 0 56 0 C74 0 98 5 112 24 C98 43 74 48 56 48 C38 48 14 43 0 24Z"
        stroke="#C4790A"
        strokeWidth="4"
        fill="none"
      />
      <circle cx="56" cy="24" r="13" fill="#FDF3E0" />
      <circle cx="56" cy="24" r="8" fill="#C4790A" />
      <circle cx="59.5" cy="20.5" r="2.5" fill="white" opacity="0.95" />
      <path
        d="M46 32 Q56 40 66 32"
        stroke="#0E0C0A"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
        opacity="0.35"
      />
    </svg>
  );
}

/**
 * Shared dark modal header (logo, wordmark, tagline, headline, subtext, close).
 *
 * @param {{
 *   headline: import('react').ReactNode,
 *   subtext?: import('react').ReactNode,
 *   onClose?: () => void,
 *   headingId?: string,
 * }} props
 *
 * Headline supports italic gold accents via <em>, e.g.
 *   headline={<>Welcome <em>back.</em></>}
 */
export default function ModalHeader({ headline, subtext, onClose, headingId }) {
  return (
    <div className="modal-header">
      <div className="modal-header-glow" aria-hidden="true" />

      {typeof onClose === "function" && (
        <button
          type="button"
          className="modal-header-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}

      <div className="modal-header-brand">
        <EyeMark />
        <div>
          <div className="modal-header-wordmark">
            100<em>Views</em><span>Only</span>
          </div>
          <div className="modal-header-tagline">Canada&apos;s Creator Platform</div>
        </div>
      </div>

      <h2 className="modal-header-headline" id={headingId}>
        {headline}
      </h2>
      {subtext ? <div className="modal-header-subtext">{subtext}</div> : null}
    </div>
  );
}
